import React from 'react';
import PropTypes from 'prop-types';


const DescriptionComponent = ({children}) => {
  return (
    <h3 className="description-component-wrapper small-font">
      {children}
    </h3>
  );
};

DescriptionComponent.prototype = {
    children: PropTypes.node,
}

export default DescriptionComponent;